import { PermissionEnum } from "@dashboard/graphql";
import { PluginIcon } from "@dashboard/icons/PluginIcon";
import { TranslationsIcon } from "@dashboard/icons/Translations";
import { permissionGroupListPath } from "@dashboard/permissionGroups/urls";
import { shippingZonesListUrl } from "@dashboard/shipping/urls";
import { languageListUrl } from "@dashboard/translations/urls";
import { Shield, Truck } from "lucide-react";
import { IntlShape } from "react-intl";

import { MenuSection } from "./types";
import { configurationPluginAdminEmailsUrl, configurationPluginUserEmailsUrl } from "./urls";

export function createConfigurationMenu(intl: IntlShape): MenuSection[] {
  return [
    {
      label: intl.formatMessage({
        id: "Y7YYuq",
        defaultMessage: "Localization",
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            id: "6l6w5J",
            defaultMessage: "Manage translated content across supported languages",
          }),
          icon: <TranslationsIcon />,
          permissions: [PermissionEnum.MANAGE_TRANSLATIONS],
          title: intl.formatMessage({
            id: "aFyu8N",
            defaultMessage: "Translations",
          }),
          url: languageListUrl,
          testId: "configuration-menu-translations",
        },
      ],
    },
    {
      label: intl.formatMessage({
        id: "gFJ4sU",
        defaultMessage: "Staff",
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            id: "QqV1kg",
            defaultMessage: "Manage staff access levels and permission sets",
          }),
          icon: <Shield size={18} />,
          permissions: [PermissionEnum.MANAGE_STAFF],
          title: intl.formatMessage({
            id: "yVIos7",
            defaultMessage: "Permission Groups",
          }),
          url: permissionGroupListPath,
          testId: "configuration-menu-permission-groups",
        },
      ],
    },
    {
      label: intl.formatMessage({
        id: "QJAllU",
        defaultMessage: "Plugins",
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            id: "D1gHKU",
            defaultMessage: "Configure staff notification email subjects",
          }),
          icon: <PluginIcon />,
          permissions: [PermissionEnum.MANAGE_PLUGINS],
          title: intl.formatMessage({
            id: "p+/258",
            defaultMessage: "Admin emails",
          }),
          url: configurationPluginAdminEmailsUrl(),
          testId: "configuration-menu-admin-emails",
        },
        {
          description: intl.formatMessage({
            id: "+7VHx8",
            defaultMessage: "Configure customer notification email subjects",
          }),
          icon: <PluginIcon />,
          permissions: [PermissionEnum.MANAGE_PLUGINS],
          title: intl.formatMessage({
            id: "5mptbg",
            defaultMessage: "User emails",
          }),
          url: configurationPluginUserEmailsUrl(),
          testId: "configuration-menu-user-emails",
        },
      ],
    },
    {
      label: intl.formatMessage({
        id: "PRlD0A",
        defaultMessage: "Shipping",
      }),
      menuItems: [
        {
          description: intl.formatMessage({
            id: "cmagNp",
            defaultMessage: "Manage shipping zones and delivery methods",
          }),
          icon: <Truck size={18} />,
          permissions: [PermissionEnum.MANAGE_SHIPPING],
          title: intl.formatMessage({
            id: "PFXGaR",
            defaultMessage: "Shipping Zones",
          }),
          url: shippingZonesListUrl(),
          testId: "configuration-menu-shipping",
        },
      ],
    },
  ];
}
